import React from "react";
import "../styles/Hero.css";
import profileImage from "../assets/profile.png"; 

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero__image">
        <img src={profileImage} alt="Profile" />
      </div>
      <div className="hero__content">
        <p className="hero__about-label">ABOUT</p>
        <h1 className="hero__name">RAJAT NAGAR...𓂃&#128395;&#65039;</h1>
        <span className="hero__tagline">Full Stack Developer</span>
        <p className="hero__description">
          Highly experienced Software Engineer proficient in Java Programming
          Language and Full Stack Development. Possessing a solid background in
          Computer Science & Engineering, with a Bachelor of Technology (B.Tech)
          degree. Demonstrated expertise in a wide range of technologies,
          including Java, DSA, MongoDB, Express.js, React.js, Node.js,
          JavaScript, and SQL.
        </p>


        <div className="hero__socials">
          <span>Find Rajat on:</span>
          <a
            href="https://www.linkedin.com/in/rajat-nagar"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://github.com/rajat705"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-github"></i>
          </a>
          <a
            href="https://leetcode.com/u/rajatnagar7893"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-code"></i>
          </a>
          <a
            href="https://www.hackerrank.com/rajatnagar7893"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-hackerrank"></i>
          </a>
          <a
            href="https://www.instagram.com/_rajatnagar_/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://x.com/rajatnagarr"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-twitter"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
